export default __webpack_public_path__ + "static/important-home-reno-36dad3e0e223a3194d619be6d2b42343.webp";